exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select-dropdown[data-v-64e92dba],.el-select-dropdown__item[data-v-64e92dba],.el-select-dropdown__item.hover[data-v-64e92dba],.el-select-dropdown__item[data-v-64e92dba]:hover{background-color:#fff!important}", ""]);

// exports
